import HeroLanding from '../../components/HeroLanding';
import videoDesktop from '../../assets/landing/sport_landing_page_mcare-horizontal.webm';
import videoMobile from '../../assets/landing/sport_landing_page_mcare-mobile.webm';
import ContactModal from '../../components/ContactModal';
import ContactForm from '../../components/contactForm/ContactForm';
import { Link } from 'react-router-dom';
import { FaLocationDot } from 'react-icons/fa6';
import Minimal from '../../components/Minimal';
import Reviews from '../../components/Reviews';
import { useState } from 'react';
import mCareSede from '../../assets/azienda/sede-mcare.png';
import reviewsBackground from '../../assets/recensioni_mcare.webp';
import DoubleImageText from '../../components/DoubleImageText';
import riabilitazione from '../../assets/landing/riabilitazione.png';
import staff from '../../assets/landing/staff.png';
import Percorso from '../../components/Percorso';
import valutazione from '../../assets/landing/valutazione.jpg';
import recupero from '../../assets/landing/recupero.jpg';
import ritorno from '../../assets/landing/ritorno.jpg';
import GridBoxV2 from '../../components/GridBoxV2';
import tennis from '../../assets/landing/tennis.png';
import basket from '../../assets/landing/basket.png';
import padel from '../../assets/landing/padel.png';
import volley from '../../assets/landing/volley.png';
import cyclingVideo from '../../assets/landing/ciclista.mp4';
import TextVideo from '../../components/TextVideo';
import LogosMarquee from '../../components/LogosMarquee';



export default function LandingSport() {
    const [contactModal, setContactModal] = useState(false);

    const closeContactModal = () => {
        setContactModal(false);
    };

    const reviews = [
  {
    title: 'Ronaldo Pompeu',
    subtitle: 'Calciatore professionista',
    stars: 5,
    text: 'Grazie ai fisioterapisti di Mcare sono tornato in campo al massimo della forma dopo l’intervento di ricostruzione del legamento crociato anteriore.'
  },
  {
    title: 'Manuel Martic',
    subtitle: 'Calciatore professionista',
    stars: 5,
    text: 'Un grande grazie a tutto il team della Mcare. Voglio ringraziarvi di cuore per il vostro supporto, la vostra pazienza e la vostra professionalità in queste settimane. Mi avete aiutato a ritrovare la mia forza giorno dopo giorno e ad avvicinarmi passo dopo passo al mio rientro in campo. Sono davvero grato di aver condiviso questo percorso con voi.'
  },
  {
    title: 'Franco Ferrari',
    subtitle: 'Calciatore professionista',
    stars: 5,
    text: 'Centro top! Grazie alla professionalità dei fisioterapisti, ho recuperato alla grande dalla rottura del legamento crociato anteriore.'
  },
];

    const doubleImageTextData = {
        title: "Non torni solo in campo, torni a essere te stesso",
        text:<div className="text-white text-lg"> 
       
        <p>
            Dopo un infortunio, recuperare significa molto più che tornare ad allenarsi.
        </p>
        <p className="mt-4">
            Il <strong>Metodo Mcare</strong> ti accompagna dal recupero della funzione al ritorno al gesto sportivo, lavorando per ritrovare forza, controllo, sicurezza e capacità di esprimere nuovamente la tua performance.
        </p>
        </div>,
        image1: staff,
        alt1: "Baschirotto e Vignato hanno scelto Mcare per il loro recupero sportivo",
        image2: riabilitazione,
        alt2: "riabilitazione e ritorno alla performance per Roberto Inglese insieme al supporto di Riccardo Meggiorini",
        image1Description: <>
            Lavoro di recupero insieme a <strong>Federico Baschirotto</strong>, difensore del Lecce, e <strong>Emanuel Vignato</strong>, attaccante del Pisa.
        </>,
        image2Description: <>
            Riabilitazione sul campo con <strong>Roberto Inglese</strong> e il supporto di <strong>Riccardo Meggiorini</strong>.
        </>
    };

    const percorsoData = {
        title: "Un percorso specifico e dedicato",
        subtitle: "Il percorso evolve insieme a te: dalla valutazione iniziale al recupero delle capacità necerssarie per tornare ad allenarti e competere.",
        tags: ["VALUTAZIONE", "RECUPERO", "RITORNO ALLA PERFORMANCE"],
        images: [
            {
                src: valutazione,
                alt: "Lavoro di riabilitazione con i professionisti di Mcare",
                title: "Metodo scientifico",
                description: "In Mcare ci affidiamo a un metodo scientifico basato su ricerca, tempestività e performance."
            },
            {
                src: recupero,
                alt: "Utilizzo di macchinari ad alta tecnologia incentrati sul recupero e ritorno alla performance con Mcare",
                title: "Tecnologie",
                description: "Abbracciamo l’innovazione utilizzando le più recenti tecnologie per farti recuperare al meglio."
            },
            {
                src: ritorno,
                alt: "Lavoro di recupero e analisi di dati per la riabilitazione e ritorno alla performance con Mcare",
                title: "un team pro ",
                description: "Al tuo servizio troverai solamente terapisti qualificati e specialisti che ti supporteranno nel tuo percorso."
            }
        ]
    };

    const gridBoxV2Data = [
        {
            tag: "#POWER-SWING",
            description: "Torna a colpire con la massima potenza",
            image: tennis,
            alt: "tennista ritorna a colpire la pallina dopo recupero sportivo con Mcare"
        },
        {
            tag: "#RE-JUMP",
            description: "Recupera l’elevazione.",
            image: basket,
            alt: "giocatore di basket torna a saltare a canestro grazie alla riabilitazione fatta insieme ai professionisti di Mcare"
        },
        {
            tag: "#FAST-REACTION",
            description: "Scatto, parete, smash.",
            image: padel,
            alt: "con Mcare un giocatore di padel torna a scattare e fare smash come faceva prima"
        },
        {
            tag: "#MAX-ELEVATION",
            description: "Torna a schiacciare sopra il muro.",
            image: volley,
            alt: "pallavolista torna a schiacciare sopra il muro come faceva prima di infortunarsi grazie a Mcare"
        }
    ];

    const textVideoData = {
        title: "Agonista o Amatore, l’obiettivo resta il tuo",
        description: <div className="text-white text-lg">
            <p>Per un atleta professionista può significare tornare a competere. Per chi pratica sport nel tempo libero può voler dire tornare a correre, pedalare, giocare a padel o affrontare una partita senza sentirsi limitato. </p>
            <p className="mt-4 font-bold">Cambia il livello. Non cambia l’importanza dell’obiettivo.</p>
        </div>,
        videoSrc: cyclingVideo
    };
    
    const handleClick = () => {
       window.location.href = '#formContatti';
    };

    return (
        <main>
            <HeroLanding 
            title="Torna alla tua Performance"
            subtitle="Diamo nuova vita al tuo movimento per farti raggiungere i tuoi obiettivi."
            desktopVideoSrc={videoDesktop} 
            mobileVideoSrc={videoMobile} 
            handleClick={handleClick}
            />

            {/* <LogosMarquee /> */}

            <DoubleImageText
                title={doubleImageTextData.title}
                description={doubleImageTextData.text}
                handleClick={handleClick}
            >
                <div className="relative flex items-center px-6 md:px-14 md:w-1/2">
                    <div className=" w-full">
                        <div className="w-full md:w-1/2 md:ml-auto md:absolute md:left-0 md:top-20">
                            <img src={doubleImageTextData.image1} alt={doubleImageTextData.image1Description} className="w-full rounded-md object-cover shadow-lg" />
                            <p className="text-white text-sm text-center mt-3 px-10">{doubleImageTextData.image1Description}</p>
                        </div>

                        <div className="w-full md:w-1/2 mt-8 md:mt-0 md:absolute md:right-8 md:bottom-36">
                            <img src={doubleImageTextData.image2} alt={doubleImageTextData.image2Description} className="w-full rounded-md object-cover shadow-lg" />
                            <p className="text-white text-sm text-center mt-3 px-10">{doubleImageTextData.image2Description}</p>
                        </div>
                    </div>
                </div>
            </DoubleImageText>


            <Percorso
                title={percorsoData.title}
                subtitle={percorsoData.subtitle}
                tags={percorsoData.tags}
                images={percorsoData.images}
            />

            <GridBoxV2 boxes={gridBoxV2Data} />
            
            <TextVideo 
                title={textVideoData.title}
                description={textVideoData.description}
                videoSrc={textVideoData.videoSrc}
                handleClick={handleClick}
            />


            {/* TESTIMONIANZE */}
            <div className="py-16 h-screen relative flex items-center justify-center">
                <img src={reviewsBackground} alt="Testimonianze" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black opacity-30"></div>
                <Reviews reviews={reviews} />
            </div>

            {/* SEDI */}
            <Minimal
                title="Dove ci trovi"
                image={mCareSede}
                alt
                imageMobileHidden={false}
                sideSection={false}
                containerWidth="w-full"
                extraClass="space-y-20"
                content={
                    <div className='grid md:grid-cols-2 grid-cols-1 place-content-center md:gap-24 gap-16 mx-4 md:mx-0'>
                        <div className='flex flex-col items-center gap-10'>
                            <FaLocationDot size={40} color="white" />
                            <Link to="https://maps.app.goo.gl/wqGkMEmPocxQ7DjXA" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Enrico Fermi 13/A, 37135, Verona</Link>
                        </div>
                        <div className='flex flex-col items-center gap-1'>
                            <div className='flex flex-col items-center gap-10'>
                                <FaLocationDot size={40} color="white" />
                                <Link to="https://maps.app.goo.gl/xyPVjWf95XXx7KPA8" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Toscana 13, 37060, Sona (VR)</Link>
                            </div>
                            {/* <p className='uppercase text-sm text-white italic bg-mcare-green py-1 px-2 rounded-sm mt-2'>Prossima apertura Settembre 2026</p> */}
                        </div>
                    </div>
                } />

            {/* sez. contatti */}
            <div className="grid grid-cols-4 gap-0" id='formContatti'>
                <div className="col-span-4 flex justify-center items-center py-32 bg-black">
                    <div className="w-full absolute z-0" style={{ "height": "120%" }}></div>
                    <div className='w-full lg:w-2/6 z-30 px-5'>
                        <p className='text-center text-4xl font-semibold mb-6 text-mcare-green panoragraf-light'>Prenota una visita</p>
                        <ContactForm
                            LandingName='mcare'
                            Name={true}
                            NameClass='text-slate-50'
                            NameText='Nome e Cognome:'
                            NameRequired={true}
                            Tel={true}
                            TelClass='text-slate-50'
                            TelText='Telefono:'
                            TelRequired={true}
                            Email={true}
                            EmailClass='text-slate-50'
                            EmailText='Email:'
                            EmailRequired={true}
                            Dropdown={true}
                            DropdownText="Scegli il centro:"
                            DropdownRequired={true}
                            DropdownItem={[' ', 'Mcare Verona', 'Mcare Sona']}
                            DropdownClass='text-slate-50'
                            ConsensoDati={true}
                            ConsensoDatiRequired={true}
                            ConsensoDatiText="Consenso dati"
                            ConsensoDatiID={1}
                            ConsensoDatiClass='text-slate-50'
                            successText='Messaggio inviato con successo!'
                            successLink='/'
                            errorText='Si è verificato un errore, Riprova!'
                            SendText='Invia'
                            SendClass='progress-button-mcare w-full '
                        />
                    </div>
                </div>
            </div>
            <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
        </main>
    );
}